<template>
    <div class="w-100">
        <v-card-title class="title font-weight-regular justify-space-between">
            Saisir le montant de la commission
            <v-avatar
                color="primary lighten-2"
                class="subheading white--text"
                size="24"
                v-text="step"
                v-if="step"
            />
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col class="pb-4">
                    <div class="body-1">{{ title }}</div>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <oss-text-field-filled
                        :min="0"
                        :suffix="'&#x20ac;'"
                        :label="'Commission nette'"
                        v-model="netCommission"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <oss-text-field-filled
                        :min="0"
                        :suffix="'&#x20ac;'"
                        :label="'Montant TVA'"
                        v-model="vatCommissionAmount"
                    />
                </v-col>
            </v-row>
            <v-row>
                <v-col v-if="vatCommissionAmount">
                    <oss-text-field-filled
                        :min="0"
                        :suffix="'&#x20ac;'"
                        :label="'Commission ttc'"
                        v-model="grossCommission"
                    />
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions v-if="!actions">
            <v-btn rounded @click="cancel()" style="margin: center" size="small">{{
                step ? "Précédent" : "Annuler"
            }}</v-btn>
            <v-spacer />
            <v-btn
                @click="addCommission"
                :loading="loading"
                :disabled="disabledAddCommissionValidate()"
                size="small"
                >Valider</v-btn
            >
        </v-card-actions>
    </div>
</template>

<script lang="ts">
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import CREATE_COMMISSION from "../../graphql/reconciliation/CreateCommission.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    emits: ["added", "cancel"],
})
export class Commission extends Vue {
    @Prop({ default: null }) step: any;
    @Prop({ default: null }) reconciliationVue: any;
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: null }) btItem: any;
    @Prop({ default: null }) actions: any;

    loading: boolean = false;

    netCommission = 0.0;
    vatCommissionAmount = 0.0;
    // commissionDate:any = {}

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    get grossCommission() {
        return this.netCommission + this.vatCommissionAmount;
    }

    get title() {
        if (this.btItem) {
            return (
                (this.btItem.bt.wordingDisplay || this.btItem.bt.wordingOriginal) +
                " - " +
                newCommonFormatCurrency(this.btItem.bt.amount)
            );
        }
        return "XXX";
    }

    get totalBTAmount() {
        // let amount = 0.0;
        // for (const item of this.reconciliationVue.reconciliationItems) {
        //     if (item.bt && item.bt.account.type === "BANK") amount += item.bt.amount;
        // }
        return this.btItem.amountSigned;
    }

    get total() {
        return this.totalBTAmount;
    }

    beforeMount() {
        if (this.actions) {
            this.actions.action.title = "Valider";
            this.actions.action.disabled = this.disabledAddCommissionValidate;
            this.actions.action.function = this.addCommission;
            this.actions.action.loading = () => {
                return this.loading;
            };
        }

        if (this.total > 0) {
            this.netCommission = this.total;
        }
    }

    disabledAddCommissionValidate() {
        if (this.netCommission <= 0) return true;
        if (this.total > 0) {
            if (this.netCommission > this.total) {
                return true;
            }
        }
        // else {
        //     if (Math.abs(this.netCommission + this.vatCommissionAmount + this.total) >= 1.e-2 ) {
        //         return true
        //     }
        // }
        return false;
    }

    async addCommission() {
        this.loading = true;
        if (this.btItem) {
            if (this.netCommission > 0) {
                // const wording = this.btItem.bt.wordingDisplay || this.btItem.bt.wordingOriginal

                // let index = 0
                // const accountingLines = []
                await this.$apollo.mutate({
                    mutation: CREATE_COMMISSION,
                    variables: {
                        bankTransactionId: this.btItem.bt.id,
                        netAmount: this.netCommission,
                        vatAmount: this.vatCommissionAmount,
                    },
                });

                await this.reconciliationVue.refresh();
                // }
                this.netCommission = 0.0;
                this.vatCommissionAmount = 0.0;

                this.$emit("added");
            }
        }
        this.loading = false;
    }

    cancel() {
        this.$emit("cancel");
    }
}

export default toNative(Commission);
</script>
